import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ayarlariGetir, ayarKaydet, ayarVarsayilanaDon, fabrikaAyarlari } from '../../services/reklamApi';

// AYARLAR — kullanıcı talebi: 2026-08-18. "Diğer" sekmesinin yerini aldı.
//
// Kapsam KASITLI olarak kullanıcı tercihi seviyesinde: süreler, eşikler, açık/kapalı anahtarları.
// Veritabanı listesi, Meta API sürümü gibi mühendislik sabitleri burada YOK — yanlış bir değer
// tüm lead akışını durdurabilir; kullanıcının ayarlar ekranından yapabileceği bir hata olmamalı.
//
// TASLAK MANTIĞI (kullanıcı talebi: "KAYDET demeden kaydedilmesin"): ekranda yapılan değişiklik
// önce yerel taslağa yazılır, hiçbir şey sunucuya gitmez. Sağ üstteki KAYDET yalnızca değişiklik
// varken etkinleşir ve tüm değişiklikleri topluca gönderir. Böylece tek tıklamayla yanlışlıkla
// bir akış kapatılamaz.
export default function Ayarlar() {
  const [durum, setDurum] = useState('yukleniyor');
  const [gruplar, setGruplar] = useState([]);
  const [hata, setHata] = useState('');
  const [acikTooltip, setAcikTooltip] = useState(null);
  const [taslak, setTaslak] = useState({});        // anahtar -> yeni değer (yalnızca değişenler)
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [sonuc, setSonuc] = useState('');
  const [satirHata, setSatirHata] = useState({});  // anahtar -> hata metni

  const GUNLER = [
    { k: 'Pzt', ad: 'Pzt' }, { k: 'Sal', ad: 'Sal' }, { k: 'Car', ad: 'Çar' },
    { k: 'Per', ad: 'Per' }, { k: 'Cum', ad: 'Cum' }, { k: 'Cmt', ad: 'Cmt' }, { k: 'Paz', ad: 'Paz' },
  ];

  // Grup kimliğine göre renk. Amaç süs değil ayrım: dört farklı sorumluluk alanı var,
  // göz hangi bölümde olduğunu okumadan bilsin.
  const GRUP_RENK = {
    LeadAkisi:     { ana: '#1F6FB2', zemin: '#EEF4FA', kenar: '#CADDEE', simge: '↻' },
    AnalizOneri:   { ana: '#6B4FA8', zemin: '#F3EFFA', kenar: '#DCD1EE', simge: '◎' },
    KararEsikleri: { ana: '#B8860B', zemin: '#FBF6E8', kenar: '#EADFBE', simge: '⚖' },
    IcerikUretim:  { ana: '#1D7A56', zemin: '#EEF7F2', kenar: '#CBE5D8', simge: '🎬' },
    Sistem:        { ana: '#4A5C63', zemin: '#F1F4F5', kenar: '#D8E0E2', simge: '⚙' },
  };
  const renk = (g) => GRUP_RENK[g] || GRUP_RENK.Sistem;

  const yukle = useCallback(() => {
    setDurum('yukleniyor');
    ayarlariGetir()
      .then(r => { setGruplar(r.data.gruplar || []); setTaslak({}); setSatirHata({}); setDurum('hazir'); })
      .catch(e => { setHata(e.response?.data?.hata || e.message); setDurum('hata'); });
  }, []);

  useEffect(() => { yukle(); }, [yukle]);

  const degerAl = (a) => (taslak[a.anahtar] !== undefined ? taslak[a.anahtar] : (a.deger ?? ''));
  const degistiMi = (a) => taslak[a.anahtar] !== undefined && String(taslak[a.anahtar]) !== String(a.deger ?? '');

  const degisiklikSayisi = useMemo(() => {
    let n = 0;
    gruplar.forEach(g => g.ayarlar.forEach(a => { if (degistiMi(a)) n++; }));
    return n;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taslak, gruplar]);

  const yaz = (a, yeni) => {
    setSonuc('');
    setSatirHata(h => ({ ...h, [a.anahtar]: '' }));
    setTaslak(t => ({ ...t, [a.anahtar]: String(yeni) }));
  };

  const hepsiniKaydet = () => {
    const degisenler = [];
    gruplar.forEach(g => g.ayarlar.forEach(a => { if (degistiMi(a)) degisenler.push([a.anahtar, taslak[a.anahtar]]); }));
    if (degisenler.length === 0) return;

    setKaydediliyor(true);
    setSonuc('');
    Promise.allSettled(degisenler.map(([k, v]) => ayarKaydet(k, v).catch(e => {
      const mesaj = e.response?.data?.hata || e.message;
      setSatirHata(h => ({ ...h, [k]: mesaj }));
      throw e;
    })))
      .then(sonuclar => {
        const basarili = sonuclar.filter(s => s.status === 'fulfilled').length;
        const basarisiz = sonuclar.length - basarili;
        setKaydediliyor(false);
        setSonuc(basarisiz === 0
          ? `✓ ${basarili} ayar kaydedildi`
          : `${basarili} kaydedildi, ${basarisiz} hatalı — kırmızı satırlara bakın`);
        if (basarisiz === 0) yukle();
      });
  };

  const vazgec = () => { setTaslak({}); setSatirHata({}); setSonuc(''); };

  const girdiAlani = (a) => {
    const v = degerAl(a);
    const dirty = degistiMi(a);
    const cerceve = satirHata[a.anahtar] ? '#C0392B' : dirty ? '#B8860B' : 'var(--border)';

    if (a.tip === 'bool') {
      return (
        <div style={{ display: 'inline-flex', border: `1px solid ${cerceve}`, borderRadius: 7, overflow: 'hidden' }}>
          {[['1', 'Evet', '#1D9E75', '#EAF6F0', '#1D7A56'], ['0', 'Hayır', '#C0392B', '#FDECEA', '#C0392B']]
            .map(([val, ad, kenar, zemin, yazi]) => {
              const secili = String(v) === val;
              return (
                <button key={val} onClick={() => yaz(a, val)} style={{
                  border: 'none', borderRight: val === '1' ? `1px solid ${cerceve}` : 'none',
                  background: secili ? zemin : '#fff',
                  color: secili ? yazi : '#9AA7AC',
                  fontWeight: secili ? 700 : 500,
                  padding: '6px 18px', fontSize: 12.5, cursor: 'pointer', minWidth: 62,
                  boxShadow: secili ? `inset 0 -2px 0 ${kenar}` : 'none',
                }}>{ad}</button>
              );
            })}
        </div>
      );
    }

    if (a.tip === 'gunler') {
      const secili = String(v || '').split(',').map(x => x.trim()).filter(Boolean);
      return (
        <div style={{ display: 'flex', gap: 4 }}>
          {GUNLER.map(g => {
            const acik = secili.includes(g.k);
            return (
              <button key={g.k} onClick={() => {
                const yeni = acik ? secili.filter(x => x !== g.k) : secili.concat(g.k);
                if (yeni.length === 0) return;   // en az bir gün kalmalı
                yaz(a, yeni.join(','));
              }} style={{
                border: `1px solid ${acik ? '#1D9E75' : 'var(--border)'}`,
                background: acik ? '#EAF6F0' : '#fff',
                color: acik ? '#1D7A56' : '#9AA7AC',
                fontWeight: acik ? 700 : 500,
                borderRadius: 6, padding: '6px 0', fontSize: 12, cursor: 'pointer', width: 42,
              }}>{g.ad}</button>
            );
          })}
        </div>
      );
    }

    // Sunucu bir seçenek listesi verdiyse serbest yazı yok: yanlış model adı ancak üretim
    // anında hata verirdi, kullanıcı sebebini geç öğrenirdi.
    if (Array.isArray(a.secenekler) && a.secenekler.length > 0) {
      return (
        <select value={v} onChange={e => yaz(a, e.target.value)} style={{
          padding: '6px 9px', fontSize: 13, border: `1px solid ${cerceve}`, borderRadius: 7,
          background: dirty ? '#FFFBF0' : '#fff', minWidth: 190, maxWidth: 240,
        }}>
          {(a.secenekler.includes(v) ? a.secenekler : [v, ...a.secenekler]).map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      );
    }

    if (a.tip === 'metin') {
      return (
        <input type="text" value={v} onChange={e => yaz(a, e.target.value)} style={{
          width: 220, padding: '6px 9px', fontSize: 13,
          border: `1px solid ${cerceve}`, borderRadius: 7,
          background: dirty ? '#FFFBF0' : '#fff',
        }} />
      );
    }

    const tipi = a.tip === 'saat' ? 'time' : 'number';
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, justifyContent: 'flex-end' }}>
        <input type={tipi} value={v}
          step={a.tip === 'ondalik' ? '0.1' : undefined}
          min={a.altSinir !== null ? a.altSinir : undefined}
          max={a.ustSinir !== null ? a.ustSinir : undefined}
          onChange={e => yaz(a, e.target.value)}
          style={{
            width: a.tip === 'saat' ? 108 : 88, padding: '6px 9px', fontSize: 13,
            border: `1px solid ${cerceve}`, borderRadius: 7, textAlign: 'right',
            background: dirty ? '#FFFBF0' : '#fff', fontVariantNumeric: 'tabular-nums',
          }} />
        <span style={{ fontSize: 12, color: 'var(--text-muted)', width: 44 }}>{a.birim || ''}</span>
      </div>
    );
  };

  return (
    <div style={{ maxWidth: 900 }}>
      {/* ---- başlık + KAYDET ---- */}
      <div style={{
        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
        gap: 16, marginBottom: 14, flexWrap: 'wrap',
      }}>
        <div style={{ minWidth: 0 }}>
          <h3 style={{ fontSize: 15, fontWeight: 600, margin: '0 0 4px' }}>Ayarlar</h3>
          <div style={{ fontSize: 11.5, color: 'var(--text-muted)', maxWidth: 560, lineHeight: 1.55 }}>
            Değişiklikler <strong>Kaydet</strong> demeden uygulanmaz. Kaydettiğinizde anında geçerli
            olur, servisin yeniden başlatılması gerekmez. Her satırdaki <strong>?</strong> ne
            değişeceğini anlatır.
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {sonuc && (
            <span style={{
              fontSize: 12, fontWeight: 600,
              color: sonuc.startsWith('✓') ? '#1D7A56' : '#C0392B',
            }}>{sonuc}</span>
          )}
          {degisiklikSayisi > 0 && (
            <button onClick={vazgec} style={{
              border: '1px solid var(--border)', background: '#fff', color: 'var(--text-muted)',
              borderRadius: 7, padding: '8px 14px', fontSize: 12.5, cursor: 'pointer',
            }}>Vazgeç</button>
          )}
          <button onClick={hepsiniKaydet} disabled={degisiklikSayisi === 0 || kaydediliyor}
            style={{
              border: 'none', borderRadius: 7, padding: '9px 20px', fontSize: 13, fontWeight: 700,
              background: degisiklikSayisi === 0 ? '#E4E9EA' : '#1D9E75',
              color: degisiklikSayisi === 0 ? '#9AA7AC' : '#fff',
              cursor: degisiklikSayisi === 0 || kaydediliyor ? 'default' : 'pointer',
              boxShadow: degisiklikSayisi === 0 ? 'none' : '0 1px 3px rgba(29,158,117,.35)',
              whiteSpace: 'nowrap',
            }}>
            {kaydediliyor ? 'Kaydediliyor...' : degisiklikSayisi === 0 ? 'Kaydet' : `Kaydet (${degisiklikSayisi})`}
          </button>
        </div>
      </div>

      {durum === 'yukleniyor' && <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>⏳ Yükleniyor...</div>}
      {durum === 'hata' && <div style={{ fontSize: 13, color: '#D9534F' }}>● {hata}</div>}

      {durum === 'hazir' && gruplar.map(g => {
        const r = renk(g.anahtar);
        return (
          <div key={g.anahtar} style={{
            background: '#fff', border: '1px solid var(--border)', borderRadius: 10,
            marginBottom: 14, overflow: 'hidden',
            boxShadow: '0 1px 2px rgba(18,33,42,.05)',
          }}>
            <div style={{
              padding: '9px 16px', background: r.zemin, borderBottom: `1px solid ${r.kenar}`,
              fontSize: 12.5, fontWeight: 700, color: r.ana,
              display: 'flex', alignItems: 'center', gap: 8,
            }}>
              <span style={{ fontSize: 14 }}>{r.simge}</span>{g.ad}
            </div>

            {g.ayarlar.map((a, i) => {
              const dirty = degistiMi(a);
              return (
                <div key={a.anahtar} style={{
                  borderTop: i === 0 ? 'none' : '1px solid #F0F3F4',
                  background: dirty ? '#FFFDF6' : '#fff',
                  borderLeft: dirty ? '3px solid #B8860B' : '3px solid transparent',
                }}>
                  <div style={{
                    display: 'grid', gridTemplateColumns: 'minmax(0,1fr) 290px',
                    alignItems: 'center', gap: 16, padding: '10px 16px',
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 7, minWidth: 0 }}>
                      <span style={{ fontSize: 13, fontWeight: 600 }}>{a.etiket || a.anahtar}</span>
                      <button onClick={() => setAcikTooltip(acikTooltip === a.anahtar ? null : a.anahtar)}
                        title="Bu ayar ne işe yarar?" style={{
                          width: 17, height: 17, lineHeight: '15px', textAlign: 'center', padding: 0,
                          borderRadius: '50%', border: `1px solid ${acikTooltip === a.anahtar ? r.ana : 'var(--border)'}`,
                          background: acikTooltip === a.anahtar ? r.ana : '#fff',
                          color: acikTooltip === a.anahtar ? '#fff' : '#9AA7AC',
                          fontSize: 11, fontWeight: 700, cursor: 'pointer', flexShrink: 0,
                        }}>?</button>

                      {!a.varsayilandaMi && !dirty && (
                        <button onClick={() => ayarVarsayilanaDon(a.anahtar).then(yukle)}
                          title={`Fabrika değeri: ${a.varsayilan}`} style={{
                            border: 'none', background: 'none', color: r.ana, fontSize: 11,
                            cursor: 'pointer', padding: 0, flexShrink: 0,
                          }}>↺ varsayılan</button>
                      )}
                      {dirty && (
                        <span style={{ fontSize: 10.5, color: '#B8860B', fontWeight: 700, flexShrink: 0 }}>
                          değişti · {a.deger} →
                        </span>
                      )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>{girdiAlani(a)}</div>
                  </div>

                  {satirHata[a.anahtar] && (
                    <div style={{ padding: '0 16px 9px', fontSize: 11.5, color: '#C0392B', fontWeight: 600 }}>
                      {satirHata[a.anahtar]}
                    </div>
                  )}

                  {acikTooltip === a.anahtar && (
                    <div style={{
                      margin: '0 16px 12px', padding: '11px 14px', background: r.zemin,
                      border: `1px solid ${r.kenar}`, borderRadius: 8,
                      fontSize: 12.5, lineHeight: 1.7, color: '#3C4A50',
                    }}>
                      {a.aciklama || 'Açıklama girilmemiş.'}
                      <div style={{ marginTop: 7, fontSize: 11, color: r.ana, fontWeight: 600 }}>
                        Fabrika değeri: {a.varsayilan}{a.birim ? ' ' + a.birim : ''}
                        {(a.altSinir !== null || a.ustSinir !== null) &&
                          ` · izin verilen aralık: ${a.altSinir ?? '?'} – ${a.ustSinir ?? '?'}`}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}

      {durum === 'hazir' && (
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          marginTop: 18, paddingTop: 14, borderTop: '1px solid var(--border)', gap: 12, flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: 11.5, color: 'var(--text-muted)' }}>
            Bir ayarı tek tek geri almak için satırdaki <strong>↺ varsayılan</strong> bağlantısını kullanın.
          </span>
          <button onClick={() => {
            if (!window.confirm('TÜM ayarlar fabrika değerlerine dönecek. Emin misiniz?')) return;
            fabrikaAyarlari().then(r => { setSonuc(`✓ ${r.data.degisen} ayar fabrika değerine döndü`); yukle(); });
          }} style={{
            border: '1px solid #E0C4C0', background: '#fff', color: '#C0392B',
            borderRadius: 7, padding: '7px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
          }}>Tümünü fabrika ayarlarına döndür</button>
        </div>
      )}
    </div>
  );
}
